import React, { useContext } from 'react'
import useFastPass, { defaultState, UseFastPass } from '../libs/useFastPass'
import { EnvVariablesContext } from '../contexts/EnvVariablesContext'


export const FastPassContext = React.createContext<UseFastPass>(defaultState)

const { Provider } = FastPassContext

const FastPassProvider = ({ children }) => {

  const { hostUrl  } = useContext(EnvVariablesContext)
  const fastPassState = useFastPass(hostUrl)

  return <Provider value={fastPassState}>{children}</Provider>

}

export default FastPassProvider
